// import React, { useState } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faUser,
//   faList,
//   faShieldAlt,
//   faBell,
//   faColumns,
//   faTrophy,
//   faSignOutAlt,
//   faCog,
//   faPenRuler,
// } from "@fortawesome/free-solid-svg-icons";
// import { createBrowserHistory } from "history";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// const history = createBrowserHistory();

// const Sidebar = ({ onToggle }) => {
//   const [open, setOpen] = useState(false);
//   const [hoveredItem, setHoveredItem] = useState(null);

//   const navigate = useNavigate();
//   const URL = "https://kaasbackend.vetrinahealthcare.com/";
//   const token = localStorage.getItem("jwttoken");

//   const role = localStorage.getItem("role");

//   const logout = () => {
//     axios
//       .post(
//         `${URL}auth/logout/`,
//         {},
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       )
//       .then(() => {
//         localStorage.removeItem("jwttoken");
//         navigate("/Log");
//       })
//       .catch((reason) => {
//         alert(reason);
//         localStorage.removeItem("jwttoken");
//         navigate("/Log");
//       });
//   };

//   const toggleSideBar = () => {
//     setOpen(!open);
//     if (onToggle) onToggle(!open); // Notify parent of state change
//   };

//   const sidebarStyles = {
//     sidebar: {
//       width: open ? "260px" : "70px",
//       minWidth: open ? "260px" : "70px",
//       zIndex: 1000,
//       transition: "all 0.25s ease-in-out",
//       display: "flex",
//       flexDirection: "column",
//       background: "linear-gradient(to bottom, #f4811ee5, #c94d00)",
//       borderRadius: "10px",
//       marginLeft: "20px",
//       marginTop: "10px",
//       marginBottom: "15px",
//       boxShadow: "0 2px 10px rgba(0, 0, 0, 0.4)",
//       overflow: "hidden",
//       height: "calc(100vh - 60px)",
//       position: "fixed",
//       top: "55px",
//     },
//     sidebarLink: {
//       display: "flex",
//       alignItems: "center",
//       padding: "12px 15px",
//       color: "white",
//       textDecoration: "none",
//       borderRadius: "25px",
//       margin: "0 12px 25px 12px",
//       transition: "all 0.2s ease",
//       ":hover": {
//         backgroundColor: "rgba(255, 255, 255, 0.2)",
//       },
//     },
//     iconText: {
//       marginLeft: "10px",
//       color: "white",
//       fontWeight: "bold",
//       display: open ? "inline-block" : "none",
//       transition: "all 0.2s ease",
//     },
//     toggleBtn: {
//       background: "transparent",
//       border: "0px",
//       borderRadius: "10px",
//       overflow: "hidden",
//       marginLeft: "auto",
//       padding: "1rem 1.5rem",
//       cursor: "pointer",
//     },
//     closeBtnSymbol: {
//       fontSize: "20px",
//       color: "white",
//       fontWeight: "bold",
//     },
//     sidebarNav: {
//       padding: "0",
//       flex: "1 1 auto",
//       boxSizing: "border-box",
//       backgroundColor: "transparent",
//     },
//     hoverText: {
//       display: !open ? "inline-block" : "none",
//       position: "absolute",
//       left: "70px",
//       backgroundColor: "#3d0d74",
//       color: "white",
//       padding: "5px 10px",
//       borderRadius: "4px",
//       zIndex: 1001,
//       whiteSpace: "nowrap",
//     },
//   };

//   function handleLogOut() {
//     localStorage.removeItem('jwttoken');
//     localStorage.removeItem('role');
//     localStorage.clear();
//     navigate('/log');
//   }

//   return (
//     <aside
//       id="sidebar"
//       style={sidebarStyles.sidebar}
//       className={open ? "expand" : ""}
//     >
//       <div style={{ display: "flex" }}>
//         <button
//           className="toggle-btn"
//           type="button"
//           onClick={toggleSideBar}
//           style={sidebarStyles.toggleBtn}
//         >
//           <span style={sidebarStyles.closeBtnSymbol}>
//             {open ? "<<" : ">>"}
//           </span>
//         </button>
//       </div>
//       <ul style={sidebarStyles.sidebarNav}>
//         <li
//           style={{ position: "relative" }}
//           onMouseEnter={() => setHoveredItem("Dashboard")}
//           onMouseLeave={() => setHoveredItem(null)}
//           onClick={() => navigate("/dashboard")}
//         >
//           <a href=" " style={sidebarStyles.sidebarLink}>
//             <FontAwesomeIcon icon={faList} style={{ color: "white" }} />
//             <span style={sidebarStyles.iconText}>Dashboard</span>
//             {!open && hoveredItem === "Dashboard" && (
//               <span style={sidebarStyles.hoverText}>Dashboard</span>
//             )}
//           </a>
//         </li>
//         <li
//           style={{ position: "relative" }}
//           onMouseEnter={() => setHoveredItem("My Profile")}
//           onMouseLeave={() => setHoveredItem(null)}
//           onClick={() => navigate("/profile")}
//         >
//           <a href=" " style={sidebarStyles.sidebarLink}>
//             <FontAwesomeIcon icon={faUser} style={{ color: "white" }} />
//             <span style={sidebarStyles.iconText}>My Profile</span>
//             {!open && hoveredItem === "My Profile" && (
//               <span style={sidebarStyles.hoverText}>My Profile</span>
//             )}
//           </a>
//         </li>
//         <li
//           style={{ position: "relative" }}
//           onMouseEnter={() => setHoveredItem("My Courses")}
//           onMouseLeave={() => setHoveredItem(null)}
//           onClick={() => navigate("/courses")}
//         >
//           <a href=" " style={sidebarStyles.sidebarLink}>
//             <FontAwesomeIcon icon={faShieldAlt} style={{ color: "white" }} />
//             <span style={sidebarStyles.iconText}>My Courses</span>
//             {!open && hoveredItem === "My Courses" && (
//               <span style={sidebarStyles.hoverText}>My Courses</span>
//             )}
//           </a>
//         </li>
//         <li
//           style={{ position: "relative" }}
//           onMouseEnter={() => setHoveredItem("My Certificates")}
//           onMouseLeave={() => setHoveredItem(null)}
//           onClick={() => navigate("/certificates")}
//         >
//           <a href=" " style={sidebarStyles.sidebarLink}>
//             <FontAwesomeIcon icon={faColumns} style={{ color: "white" }} />
//             <span style={sidebarStyles.iconText}>My Certificates</span>
//             {!open && hoveredItem === "My Certificates" && (
//               <span style={sidebarStyles.hoverText}>My Certificates</span>
//             )}
//           </a>
//         </li>
//         <li
//           style={{ position: "relative" }}
//           onMouseEnter={() => setHoveredItem("My Achievements")}
//           onMouseLeave={() => setHoveredItem(null)}
//           onClick={() => navigate("/achievements")}
//         >
//           <a href=" " style={sidebarStyles.sidebarLink}>
//             <FontAwesomeIcon icon={faTrophy} style={{ color: "white" }} />
//             <span style={sidebarStyles.iconText}>My Achievements</span>
//             {!open && hoveredItem === "My Achievements" && (
//               <span style={sidebarStyles.hoverText}>My Achievements</span>
//             )}
//           </a>
//         </li>
//         {role === "Instructor" && (
//           <li
//             style={{ position: "relative" }}
//             onMouseEnter={() => setHoveredItem("Add Course")}
//             onMouseLeave={() => setHoveredItem(null)}
//             onClick={() => navigate("/createcourse")}
//           >
//             <a href=" " style={sidebarStyles.sidebarLink}>
//               <FontAwesomeIcon icon={faPenRuler} style={{ color: "white" }} />
//               <span style={sidebarStyles.iconText}>Add Course</span>
//               {!open && hoveredItem === "Add Course" && (
//                 <span style={sidebarStyles.hoverText}>Add Course</span>
//               )}
//             </a>
//           </li>
//         )}
//         <li
//           style={{ position: "relative" }}
//           onMouseEnter={() => setHoveredItem("Notification")}
//           onMouseLeave={() => setHoveredItem(null)}
//           onClick={() => navigate("/notification")}
//         >
//           <a href=" " style={sidebarStyles.sidebarLink}>
//             <FontAwesomeIcon icon={faBell} style={{ color: "white" }} />
//             <span style={sidebarStyles.iconText}>Notification</span>
//             {!open && hoveredItem === "Notification" && (
//               <span style={sidebarStyles.hoverText}>Notification</span>
//             )}
//           </a>
//         </li>
//         <li
//           style={{ position: "relative" }}
//           onMouseEnter={() => setHoveredItem("Settings")}
//           onMouseLeave={() => setHoveredItem(null)}
//           onClick={() => navigate("/settingslayout")}
//         >
//           <a href=" " style={sidebarStyles.sidebarLink}>
//             <FontAwesomeIcon icon={faCog} style={{ color: "white" }} />
//             <span style={sidebarStyles.iconText}>Settings</span>
//             {!open && hoveredItem === "Settings" && (
//               <span style={sidebarStyles.hoverText}>Settings</span>
//             )}
//           </a>
//         </li>
//         <li
//           style={{ position: "relative" }}
//           onMouseEnter={() => setHoveredItem("Logout")}
//           onMouseLeave={() => setHoveredItem(null)}
//           onClick={handleLogOut}
//         >
//           <a href=" " style={sidebarStyles.sidebarLink}>
//             <FontAwesomeIcon icon={faSignOutAlt} style={{ color: "white" }} />
//             <span style={sidebarStyles.iconText}>Logout</span>
//             {!open && hoveredItem === "Logout" && (
//               <span style={sidebarStyles.hoverText}>Logout</span>
//             )}
//           </a>
//         </li>
//       </ul>
//     </aside>
//   );
// };

// export default Sidebar;





// *************************************************************************************8


// import React, { useState, useEffect } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faUser,
//   faList,
//   faShieldAlt,
//   faBell,
//   faColumns,
//   faTrophy,
//   faSignOutAlt,
//   faCog,
//   faPenRuler,
//   faHome, // Import faHome icon
// } from "@fortawesome/free-solid-svg-icons";
// import { useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";

// const Sidebar = ({ onToggle }) => {
//   // Initialize open state based on screen width for responsiveness
//   // It will be open by default on larger screens (>768px) and closed on smaller screens.
//   const [open, setOpen] = useState(window.innerWidth > 768);
//   const [hoveredItem, setHoveredItem] = useState(null);

//   const navigate = useNavigate();
//   const location = useLocation(); // Get current location to determine active link
//   const URL = "https://kaasbackend.vetrinahealthcare.com/";
//   const token = localStorage.getItem("jwttoken");
//   const role = localStorage.getItem("role");

//   // --- Responsive Logic ---
//   useEffect(() => {
//     const handleResize = () => {
//       const isLargeScreen = window.innerWidth > 768;
//       // Adjust open state only if it doesn't match the default for the current screen size
//       if (open !== isLargeScreen) {
//         setOpen(isLargeScreen);
//         if (onToggle) onToggle(isLargeScreen);
//       }
//     };

//     // Set initial state on mount (already done by useState initial value, but good to ensure consistent notification)
//     if (onToggle) onToggle(open);

//     window.addEventListener("resize", handleResize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, [open, onToggle]); // Re-run effect if open or onToggle changes

//   // --- Logout Function ---
//   const logout = () => {
//     axios
//       .post(
//         `${URL}auth/logout/`,
//         {},
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       )
//       .then(() => {
//         localStorage.removeItem("jwttoken");
//         localStorage.removeItem("role");
//         localStorage.clear();
//         navigate("/Log");
//       })
//       .catch((reason) => {
//         alert("Logout failed: " + (reason.message || reason));
//         // Still clear local storage and navigate on error to prevent being stuck
//         localStorage.removeItem("jwttoken");
//         localStorage.removeItem("role");
//         localStorage.clear();
//         navigate("/Log");
//       });
//   };

//   // --- Toggle Sidebar for manual control ---
//   const toggleSideBar = () => {
//     setOpen(!open);
//     if (onToggle) onToggle(!open); // Notify parent of state change
//   };

//   const sidebarStyles = {
//     sidebar: {
//       width: open ? "260px" : "70px",
//       minWidth: open ? "260px" : "70px",
//       zIndex: 1000,
//       transition: "all 0.25s ease-in-out",
//       display: "flex",
//       flexDirection: "column",
//       background: "linear-gradient(to bottom, #f4811ee5, #c94d00)",
//       borderRadius: "10px",
//       marginLeft: "20px",
//       marginTop: "10px",
//       marginBottom: "15px",
//       boxShadow: "0 2px 10px rgba(0, 0, 0, 0.4)",
//       overflow: "hidden",
//       height: "calc(100vh - 60px)",
//       position: "fixed",
//       top: "55px",
//     },
//     // Base style for all sidebar links
//     sidebarLink: {
//       display: "flex",
//       alignItems: "center",
//       padding: "8px 15px", // Decreased padding
//       color: "white", // Default text color
//       textDecoration: "none",
//       borderRadius: "0px", // Set to 0px for no radius on hover/active
//       margin: "0 12px 10px 12px", // Decreased bottom margin
//       transition: "all 0.2s ease",
//     },
//     iconText: {
//       marginLeft: "10px",
//       color: "white", // Default text color
//       fontWeight: "bold",
//       display: open ? "inline-block" : "none",
//       transition: "all 0.2s ease",
//     },
//     toggleBtn: {
//       background: "transparent",
//       border: "0px",
//       borderRadius: "10px",
//       overflow: "hidden",
//       marginLeft: "auto",
//       padding: "1rem 1.5rem",
//       cursor: "pointer",
//     },
//     closeBtnSymbol: {
//       fontSize: "20px",
//       color: "white",
//       fontWeight: "bold",
//     },
//     sidebarNav: {
//       padding: "0",
//       flex: "1 1 auto",
//       boxSizing: "border-box",
//       backgroundColor: "transparent",
//     },
//     hoverText: {
//       display: !open ? "inline-block" : "none",
//       position: "absolute",
//       left: "70px",
//       backgroundColor: "#3d0d74", // Keep original hover text background
//       color: "white",
//       padding: "5px 10px",
//       borderRadius: "4px",
//       zIndex: 1001,
//       whiteSpace: "nowrap",
//     },
//     // Styles for the active link
//     activeLink: {
//       backgroundColor: "white",
//     },
//     activeIconText: {
//       color: "orange", // Icon and text color for active link
//     },
//   };

//   // Helper function to render a sidebar item
//   const renderSidebarItem = (
//     icon,
//     text,
//     path,
//     condition = true // Default condition is true, useful for role-based rendering
//   ) => {
//     if (!condition) return null;

//     const isActive = location.pathname === path; // Check if current path matches
//     const linkStyle = {
//       ...sidebarStyles.sidebarLink,
//       ...(isActive ? sidebarStyles.activeLink : {}),
//       // Add hover effect via JS for background change
//       backgroundColor: isActive
//         ? sidebarStyles.activeLink.backgroundColor
//         : hoveredItem === text
//         ? "rgba(255, 255, 255, 0.2)"
//         : "transparent",
//     };
//     const iconAndTextStyle = {
//       ...(isActive ? sidebarStyles.activeIconText : { color: "white" }),
//     };

//     return (
//       <li
//         key={text}
//         style={{ position: "relative" }}
//         onMouseEnter={() => setHoveredItem(text)}
//         onMouseLeave={() => setHoveredItem(null)}
//         onClick={() => navigate(path)}
//       >
//         <a href="#" style={linkStyle}>
//           <FontAwesomeIcon icon={icon} style={iconAndTextStyle} />
//           <span style={{ ...sidebarStyles.iconText, ...iconAndTextStyle }}>
//             {text}
//           </span>
//           {!open && hoveredItem === text && (
//             <span style={sidebarStyles.hoverText}>{text}</span>
//           )}
//         </a>
//       </li>
//     );
//   };

//   return (
//     <aside
//       id="sidebar"
//       style={sidebarStyles.sidebar}
//       className={open ? "expand" : ""}
//     >
//       <div style={{ display: "flex" }}>
//         <button
//           className="toggle-btn"
//           type="button"
//           onClick={toggleSideBar}
//           style={sidebarStyles.toggleBtn}
//         >
//           <span style={sidebarStyles.closeBtnSymbol}>
//             {open ? "<<" : ">>"}
//           </span>
//         </button>
//       </div>
//       <ul style={sidebarStyles.sidebarNav}>
//         {renderSidebarItem(faHome, "Home", "/Home")}
//         {renderSidebarItem(faList, "Dashboard", "/dashboard")}
//         {renderSidebarItem(faUser, "My Profile", "/profile")}
//         {renderSidebarItem(faShieldAlt, "My Courses", "/courses")}
//         {renderSidebarItem(faColumns, "My Certificates", "/certificates")}
//         {renderSidebarItem(faTrophy, "My Achievements", "/achievements")}
//         {renderSidebarItem(
//           faPenRuler,
//           "Add Course",
//           "/createcourse",
//           role === "Instructor"
//         )}
//         {renderSidebarItem(faBell, "Notification", "/notification")}
//         {renderSidebarItem(faCog, "Settings", "/settingslayout")}
//         {/* Logout item is handled separately as it doesn't navigate to a content page */}
//         <li
//           style={{ position: "relative" }}
//           onMouseEnter={() => setHoveredItem("Logout")}
//           onMouseLeave={() => setHoveredItem(null)}
//           onClick={logout}
//         >
//           <a
//             href="#"
//             style={{
//               ...sidebarStyles.sidebarLink,
//               backgroundColor:
//                 hoveredItem === "Logout" ? "rgba(255, 255, 255, 0.2)" : "transparent",
//             }}
//           >
//             <FontAwesomeIcon icon={faSignOutAlt} style={{ color: "white" }} />
//             <span style={sidebarStyles.iconText}>Logout</span>
//             {!open && hoveredItem === "Logout" && (
//               <span style={sidebarStyles.hoverText}>Logout</span>
//             )}
//           </a>
//         </li>
//       </ul>
//     </aside>
//   );
// };

// export default Sidebar;

// *********************************************************************************************



// import React, { useState, useEffect } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faUser,
//   faList,
//   faShieldAlt,
//   faBell,
//   faColumns,
//   faTrophy,
//   faSignOutAlt,
//   faCog,
//   faPenRuler,
//   faHome,
// } from "@fortawesome/free-solid-svg-icons";
// import { useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";

// const Sidebar = ({ onToggle }) => {
//   const [open, setOpen] = useState(window.innerWidth > 768);
//   const [hoveredItem, setHoveredItem] = useState(null);
//   const navigate = useNavigate();
//   const location = useLocation();

//   const URL = "https://kaasbackend.vetrinahealthcare.com/";
//   const token = localStorage.getItem("jwttoken");
//   const role = localStorage.getItem("role");

//   useEffect(() => {
//     const handleResize = () => {
//       const isLargeScreen = window.innerWidth > 768;
//       if (open !== isLargeScreen) {
//         setOpen(isLargeScreen);
//         if (onToggle) onToggle(isLargeScreen);
//       }
//     };
//     if (onToggle) onToggle(open);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [open, onToggle]);

//   const logout = () => {
//     axios
//       .post(`${URL}auth/logout/`, {}, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then(() => {
//         localStorage.clear();
//         navigate("/Log");
//       })
//       .catch((reason) => {
//         alert("Logout failed: " + (reason.message || reason));
//         localStorage.clear();
//         navigate("/Log");
//       });
//   };

//   const toggleSideBar = () => {
//     setOpen(!open);
//     if (onToggle) onToggle(!open);
//   };

//   const sidebarStyles = {
//     sidebar: {
//       width: open ? "260px" : "70px",
//       minWidth: open ? "260px" : "70px",
//       zIndex: 1000,
//       transition: "all 0.25s ease-in-out",
//       display: "flex",
//       flexDirection: "column",
//       background: "linear-gradient(to bottom, #f4811ee5, #c94d00)",
//       borderRadius: "10px",
//       marginLeft: "20px",
//       marginTop: "10px",
//       marginBottom: "15px",
//       boxShadow: "0 2px 10px rgba(0, 0, 0, 0.4)",
//       height: "calc(100vh - 60px)",
//       position: "fixed",
//       top: "55px",
//       overflow: "visible", // VERY IMPORTANT
//     },
//     sidebarLink: {
//       display: "flex",
//       alignItems: "center",
//       padding: "8px 15px",
//       color: "white",
//       textDecoration: "none",
//       borderRadius: "0px",
//       margin: "0 12px 10px 12px",
//       transition: "all 0.2s ease",
//       position: "relative",
//     },
//     iconText: {
//       marginLeft: "10px",
//       color: "white",
//       fontWeight: "bold",
//       display: open ? "inline-block" : "none",
//     },
//     toggleBtn: {
//       background: "transparent",
//       border: "0px",
//       marginLeft: "auto",
//       padding: "1rem 1.5rem",
//       cursor: "pointer",
//     },
//     closeBtnSymbol: {
//       fontSize: "20px",
//       color: "white",
//       fontWeight: "bold",
//     },
//     sidebarNav: {
//       padding: "0",
//       flex: "1 1 auto",
//       listStyle: "none",
//       overflow: "visible",
//     },
//     hoverText: {
//       position: "absolute",
//       top: "50%",
//       left: "80px",
//       transform: "translateY(-50%)",
//       backgroundColor: "#000000e0",
//       color: "#fff",
//       padding: "6px 12px",
//       borderRadius: "6px",
//       whiteSpace: "nowrap",
//       zIndex: 9999,
//       fontSize: "0.9rem",
//       fontWeight: "500",
//       boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
//       display: open ? "none" : "block",
//     },
//     activeLink: {
//       backgroundColor: "white",
//     },
//     activeIconText: {
//       color: "orange",
//     },
//   };

//   const renderSidebarItem = (
//     icon,
//     text,
//     path,
//     condition = true
//   ) => {
//     if (!condition) return null;
//     const isActive = location.pathname === path;
//     const linkStyle = {
//       ...sidebarStyles.sidebarLink,
//       backgroundColor: isActive
//         ? sidebarStyles.activeLink.backgroundColor
//         : hoveredItem === text
//         ? "rgba(255, 255, 255, 0.2)"
//         : "transparent",
//     };
//     const iconAndTextStyle = isActive
//       ? sidebarStyles.activeIconText
//       : { color: "white" };

//     return (
//       <li
//         key={text}
//         style={{ position: "relative", overflow: "visible" }}
//         onMouseEnter={() => setHoveredItem(text)}
//         onMouseLeave={() => setHoveredItem(null)}
//         onClick={() => navigate(path)}
//       >
//         <a href="#" style={linkStyle}>
//           <FontAwesomeIcon icon={icon} style={iconAndTextStyle} />
//           <span style={{ ...sidebarStyles.iconText, ...iconAndTextStyle }}>
//             {text}
//           </span>
//           {!open && hoveredItem === text && (
//             <span style={sidebarStyles.hoverText}>{text}</span>
//           )}
//         </a>
//       </li>
//     );
//   };

//   return (
//     <aside style={sidebarStyles.sidebar} className={open ? "expand" : ""}>
//       <div style={{ display: "flex" }}>
//         <button type="button" onClick={toggleSideBar} style={sidebarStyles.toggleBtn}>
//           <span style={sidebarStyles.closeBtnSymbol}>
//             {open ? "<<" : ">>"}
//           </span>
//         </button>
//       </div>
//       <ul style={sidebarStyles.sidebarNav}>
//         {renderSidebarItem(faHome, "Home", "/Home")}
//         {renderSidebarItem(faList, "Dashboard", "/dashboard")}
//         {renderSidebarItem(faUser, "My Profile", "/profile")}
//         {renderSidebarItem(faShieldAlt, "My Courses", "/courses")}
//         {renderSidebarItem(faColumns, "My Certificates", "/certificates")}
//         {renderSidebarItem(faTrophy, "My Achievements", "/achievements")}
//         {renderSidebarItem(faPenRuler, "Add Course", "/createcourse", role === "Instructor")}
//         {renderSidebarItem(faBell, "Notification", "/notification")}
//         {renderSidebarItem(faCog, "Settings", "/settingslayout")}
//         <li
//           style={{ position: "relative" }}
//           onMouseEnter={() => setHoveredItem("Logout")}
//           onMouseLeave={() => setHoveredItem(null)}
//           onClick={logout}
//         >
//           <a
//             href="#"
//             style={{
//               ...sidebarStyles.sidebarLink,
//               backgroundColor:
//                 hoveredItem === "Logout" ? "rgba(255, 255, 255, 0.2)" : "transparent",
//             }}
//           >
//             <FontAwesomeIcon icon={faSignOutAlt} style={{ color: "white" }} />
//             <span style={sidebarStyles.iconText}>Logout</span>
//             {!open && hoveredItem === "Logout" && (
//               <span style={sidebarStyles.hoverText}>Logout</span>
//             )}
//           </a>
//         </li>
//       </ul>
//     </aside>
//   );
// };

// export default Sidebar;





// **********************updated************************
// Make sure to import ReactDOM at the top of your file
import ReactDOM from "react-dom";
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faChartBar,
  faShieldAlt,
  faBell,
  faColumns,
  faTrophy,
  faSignOutAlt,
  faCog,
  faPenRuler,
  faHome,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

// ===================================================================
// 1. A new Tooltip component that uses a React Portal
// This component renders the tooltip directly onto the document body.
// ===================================================================
const HoverTooltip = ({ text, top, left }) => {
  // If there's no text, don't render anything
  if (!text) {
    return null;
  }

  const style = {
    position: 'fixed', // Fixed position relative to the viewport
    top: `${top}px`,
    left: `${left}px`,
    transform: 'translateY(-50%)', // Vertically center the tooltip
    backgroundColor: '#000000e0',
    color: '#fff',
    padding: '6px 12px',
    borderRadius: '6px',
    whiteSpace: 'nowrap',
    zIndex: 9999, // A very high z-index to ensure it's on top
    fontSize: '0.9rem',
    fontWeight: '500',
    boxShadow: '0px 4px 12px rgba(0,0,0,0.2)',
    pointerEvents: 'none', // Prevent the tooltip from capturing mouse events
  };

  // Use ReactDOM.createPortal to render the tooltip outside the main DOM hierarchy
  return ReactDOM.createPortal(<div style={style}>{text}</div>, document.body);
};


// ===================================================================
// 2. The Updated Sidebar Component
// ===================================================================
const Sidebar = ({ onToggle }) => {
  const [open, setOpen] = useState(window.innerWidth > 768);
  // NEW STATE: Manages the tooltip's visibility, text, and position
  const [tooltip, setTooltip] = useState({ visible: false, text: '', top: 0, left: 0 });

  const navigate = useNavigate();
  const location = useLocation();

  const URL = "https://kaasbackend.vetrinahealthcare.com/";
  const token = localStorage.getItem("jwttoken");
  const role = localStorage.getItem("role");

  useEffect(() => {
    const handleResize = () => {
      const isLargeScreen = window.innerWidth > 768;
      if (open !== isLargeScreen) {
        setOpen(isLargeScreen);
        if (onToggle) onToggle(isLargeScreen);
      }
    };
    if (onToggle) onToggle(open);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [open, onToggle]);

  const handleLogout = () => {
    localStorage.clear();
    if (token) {
      axios.post(`${URL}auth/logout/`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      }).catch(error => {
        console.error("Logout API error:", error);
      });
    }
    navigate("/Log");
  };

  const toggleSideBar = () => {
    setOpen(!open);
    if (onToggle) onToggle(!open);
  };

  // NEW HANDLERS: These now calculate the position for the tooltip portal
  const handleMouseEnter = (e, text) => {
    if (!open) {
      const rect = e.currentTarget.getBoundingClientRect();
      setTooltip({
        visible: true,
        text: text,
        top: rect.top + rect.height / 2, // Center vertically
        left: rect.right + 10, // Position to the right with a 10px gap
      });
    }
  };

  const handleMouseLeave = () => {
    setTooltip({ visible: false, text: '', top: 0, left: 0 });
  };
  
  const sidebarStyles = {
    sidebar: {
      width: open ? "260px" : "70px",
      minWidth: open ? "260px" : "70px",
      zIndex: 1000,
      transition: "all 0.25s ease-in-out",
      display: "flex",
      flexDirection: "column",
      background: "linear-gradient(to bottom, #f4811ee5, #c94d00)",
      borderRadius: "10px",
      marginLeft: "0px",
      marginTop: "10px",
      marginBottom: "15px",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.4)",
      height: "calc(100vh - 60px)",
      position: "fixed",
      top: "55px",
    },
    sidebarLink: {
      display: "flex",
      alignItems: "center",
      padding: "6px 10px",
      color: "white",
      textDecoration: "none",
      borderRadius: "6px",
      margin: "6px 8px",
      transition: "background-color 0.2s ease",
      position: "relative",
      cursor: "pointer",
    },
    iconText: {
      marginLeft: "10px",
      color: "white",
      fontWeight: "bold",
      whiteSpace: "nowrap",
      display: open ? "inline-block" : "none",
    },
    toggleBtn: {
      background: "transparent",
      border: "0px",
      marginLeft: "auto",
      padding: "1rem 1.5rem",
      cursor: "pointer",
    },
    closeBtnSymbol: {
      fontSize: "20px",
      color: "white",
      fontWeight: "bold",
    },
    scrollContainer: {
      flex: "1 1 auto",
      overflowY: "auto",
      overflowX: "hidden",
      height: "100%",
    },
    sidebarNav: {
      padding: "0",
      listStyle: "none",
    },
    activeLink: {
      backgroundColor: "white",
    },
    activeIconText: {
      color: "orange",
    },
  };

  const renderSidebarItem = (icon, text, path, condition = true) => {
    if (!condition) return null;
    const isActive = location.pathname === path;
    const linkStyle = {
      ...sidebarStyles.sidebarLink,
      backgroundColor: isActive ? sidebarStyles.activeLink.backgroundColor : 'transparent',
    };
    const iconAndTextStyle = isActive ? sidebarStyles.activeIconText : { color: "white" };

    return (
      <li
        key={text}
        style={{ position: "relative" }}
        // Use the new position-aware handlers
        onMouseEnter={(e) => handleMouseEnter(e, text)}
        onMouseLeave={handleMouseLeave}
        onClick={() => navigate(path)}
      >
        <div style={linkStyle}>
          <FontAwesomeIcon icon={icon} style={iconAndTextStyle} />
          <span style={{ ...sidebarStyles.iconText, ...iconAndTextStyle }}>
            {text}
          </span>
        </div>
      </li>
    );
  };

  return (
    <>
      {/* 3. Render the portal component. It will be invisible unless the tooltip state is active. */}
      <HoverTooltip
        text={tooltip.visible ? tooltip.text : ''}
        top={tooltip.top}
        left={tooltip.left}
      />

      <aside style={sidebarStyles.sidebar} className={open ? "expand" : ""}>
        <style>{`
          .sidebar-scroll::-webkit-scrollbar { width: 4px; }
          .sidebar-scroll::-webkit-scrollbar-track { background: transparent; }
          .sidebar-scroll::-webkit-scrollbar-thumb { background-color: rgba(255, 255, 255, 0.3); border-radius: 10px; }
          .sidebar-scroll::-webkit-scrollbar-thumb:hover { background-color: rgba(255, 255, 255, 0.5); }
        `}</style>

        <div style={{ display: "flex", flexShrink: 0 }}>
          <button
            type="button"
            onClick={toggleSideBar}
            style={sidebarStyles.toggleBtn}
          >
            <span style={sidebarStyles.closeBtnSymbol}>
              {open ? "<<" : ">>"}
            </span>
          </button>
        </div>
        
        <div style={sidebarStyles.scrollContainer} className="sidebar-scroll">
          <ul style={sidebarStyles.sidebarNav}>
            {renderSidebarItem(faHome, "Home", "/Home")}
            {renderSidebarItem(faUser, "My Profile", "/profilenew")}
            {renderSidebarItem(faShieldAlt, "My Courses", "/courses")}
            {renderSidebarItem(faChartBar, "My Progress", "/dashboard")}
            {renderSidebarItem(faColumns, "My Certificates", "/certificates")}
            {renderSidebarItem(faTrophy, "My Achievements", "/achievements")}
            {renderSidebarItem(faFileAlt, "Reports", "/reports", role === "Student")}
            {renderSidebarItem(faPenRuler, "Add Course", "/createcourse", role === "Instructor")}
            {renderSidebarItem(faBell, "Notification", "/notification")}
            {renderSidebarItem(faCog, "Settings", "/settingslayout")}
            
            {/* Logout button also uses the same portal logic */}
            <li
              style={{ position: "relative" }}
              onMouseEnter={(e) => handleMouseEnter(e, "Logout")}
              onMouseLeave={handleMouseLeave}
              onClick={handleLogout}
            >
              <div style={sidebarStyles.sidebarLink}>
                <FontAwesomeIcon icon={faSignOutAlt} style={{ color: "white" }} />
                <span style={sidebarStyles.iconText}>Logout</span>
              </div>
            </li>
          </ul>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;